import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { Toast, ToastrService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [CommonModule, NgbToastModule, AsyncPipe],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  host: { class: 'toast-container position-fixed top-0 end-0 p-3' }
})
export class ToastComponent {
  private toasts: Toast[] = [];
  toasts$ = new BehaviorSubject<Toast[]>([]);

  constructor(@Inject(ToastrService) private toastrService: ToastrService) {
    this.toastrService.toast$.subscribe(toast => {
      this.toasts.push(toast);
      this.toasts$.next(this.toasts);
    });
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
    this.toasts$.next(this.toasts);
  }
}
